module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-66.2b78f1de.svg";